module.exports = "/_next/static/images/Whenever-5c4adbd3499ad4086fb09e64fc358276.webp";